import { useState } from "react";
import { MapPin, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useScrollLock } from "../../lib/useScrollLock";

// Shows a location with a 📍 that opens Google Maps / Waze itinerary.
export const MapsWaze = ({ name, address, testid = "maps-waze" }) => {
  const [open, setOpen] = useState(false);
  useScrollLock(open);
  if (!name && !address) return null;
  const q = encodeURIComponent(address || name);
  const label = [name, address].filter(Boolean).join(" · ");
  const gmaps = `https://www.google.com/maps/search/?api=1&query=${q}`;
  const waze = `https://waze.com/ul?q=${q}&navigate=yes`;

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testid} className="inline-flex items-center gap-2 text-sm text-white/85 hover:text-electric transition-colors group">
        <MapPin size={15} className="text-electric" /> <span className="underline decoration-white/20 group-hover:decoration-electric underline-offset-4">{label}</span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div className="fixed inset-0 z-[10000] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setOpen(false)} data-testid={`${testid}-modal`}>
            <motion.div onClick={(e) => e.stopPropagation()} initial={{ scale: 0.95 }} animate={{ scale: 1 }} exit={{ scale: 0.95 }}
              className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#0a0a0a] p-7 relative text-center">
              <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-white/50 hover:text-white"><X size={18} /></button>
              <MapPin size={26} className="text-electric mx-auto mb-3" />
              <div className="font-serif text-xl text-white mb-1">{name}</div>
              {address && <div className="text-sm text-secondary2 mb-6">{address}</div>}
              <div className="flex flex-col gap-3">
                <a href={gmaps} target="_blank" rel="noreferrer" data-testid={`${testid}-gmaps`} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-electric text-black text-[12px] tracking-[0.12em] uppercase font-semibold hover:bg-white transition-colors">Ouvrir avec Google Maps</a>
                <a href={waze} target="_blank" rel="noreferrer" data-testid={`${testid}-waze`} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/20 text-white text-[12px] tracking-[0.12em] uppercase font-medium hover:border-electric hover:text-electric transition-colors">Ouvrir avec Waze</a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
